const officeExternalService = window.external as any;

class ActionFunctions {
    public action = (tcid: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.ExecuteToolbarCommand) {
                resolve(officeExternalService.ExecuteToolbarCommand(parseInt(tcid, 10)));
            } else {
                reject(false);
            }
        });
    };

    public delay = (timeout: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            setTimeout(resolve, parseInt(timeout, 10) || 2000);
        });
    };

    public showribbon = (): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.ShowRibbon) {
                resolve(officeExternalService.ShowRibbon(true));
            } else {
                reject(false);
            }
        });
    };

    public awaitedcallout = (id: string, title: string, description: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.ShowCalloutWithCallback) {
                setTimeout(officeExternalService.ShowCalloutWithCallback(resolve, id, title, description), 5000);
            } else if (!!officeExternalService && !!officeExternalService.ShowCallout) {
                setTimeout(() => {
                    officeExternalService.ShowCallout(id, title, description);
                    // @ts-ignore
                    resolve();
                }, 500);
            } else {
                reject(false);
            }
        });
    };

    public backstagecallout = (tcid: string, title: string, description: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.ShowCallout) {
                officeExternalService.ShowCallout(1, parseInt(tcid, 10), title, description);
            } else {
                reject(false);
            }
        });
    };

    public callout = (tcid: string, title: string, description: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.ShowCallout) {
                officeExternalService.ShowCallout(parseInt(tcid, 10) || tcid, title, description);
            } else {
                reject(false);
            }
        });
    };

    public diag = (...args: Array<string>): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.RunDiagnosticAction) {
                const parts = args.join('_').split(';');
                if (parts.length === 2 && officeExternalService.RunDiagnosticAction(parts[0])) {
                    window.location.href = '/f1/topic/' + parts[1];
                }
            } else {
                reject(false);
            }
        });
    };

    public outspace = (tcid: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.ShowOutspaceTcid) {
                officeExternalService.ShowOutspaceTcid(parseInt(tcid, 10));
            } else {
                reject(false);
            }
        });
    };

    public renamepane = (name: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.RenamePane) {
                officeExternalService.RenamePane(name);
            } else {
                reject(false);
            }
        });
    };

    public spotlight = (tcid: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.OnShowMe) {
                setTimeout(officeExternalService.OnShowMe(resolve, 1000, parseInt(tcid, 10)), 5000);
            } else {
                reject(false);
            }
        });
    };

    public tab = (tcid: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.OpenTab) {
                officeExternalService.OpenTab(parseInt(tcid, 10));
            } else {
                reject(false);
            }
        });
    };

    public updateInsiderLevel = (newLevel: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!!officeExternalService && !!officeExternalService.UpdateInsiderLevel) {
                officeExternalService.OnShowMe(parseInt(newLevel, 10));
            } else {
                reject(false);
            }
        });
    };
}

export const executeActions = async (actionsList: Array<string>): Promise<boolean> => {
  try {
    if (officeExternalService.IsRibbonCollapsed()) {
      // prepend actions to show ribbon and delay
      actionsList.unshift('showribbon', 'delay');
    }
  } catch (err) {
    throw new Error(err);
  }

  const actionFunctions = new ActionFunctions();

  for (const action of actionsList) {
    const parts = action.split('_');
    const actionName = parts.shift();
    try {
      const res = await actionFunctions[actionName].apply(undefined, parts);
      if (res === false) {
        throw new Error('Action function failed');
      }
    } catch (err) {
      throw new Error(err);
    }
  }

  return true;
};
